import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'react-hot-toast';
import { UiToast } from './components/ui/ui-toast';
import AppRouter from './AppRouter';
import { AuthInitializer } from './components/AuthInitializer';
import { ErrorFallback } from './components/ui/ErrorFallback';
import { AlunoProvider } from './contexts/AlunoContext';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ResponsavelAlunoProvider } from './contexts/ResponsavelAlunoContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ThemeProvider>
      <AuthProvider>
        <NotificationProvider>
          <ResponsavelAlunoProvider>
            <AlunoProvider>
            <SidebarProvider>
              <AuthInitializer>
                <AppRouter />
                <Toaster
                  position="top-right"
                  toastOptions={{ duration: 4000, style: { background: 'transparent', boxShadow: 'none', padding: 0 } }}
                >
                  {(t) => <UiToast t={t} />}
                </Toaster>
            </AuthInitializer>
          </SidebarProvider>
            </AlunoProvider>
        </ResponsavelAlunoProvider>
        </NotificationProvider>
      </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
